export const ASSET_CARD_ROW_MT = 6;
